import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Slider from "./Components/SliderDuplicate";
import Header from "./Components/Header";
import Home from "./Components/Home";
import Footer from "./Components/Footer";
import HeaderB from "./Components/HeaderB";
import FooterB from "./Components/FooterB";
import About from "./Components/About";
import Information from "./Components/Information";

function App() {
  return (
    <div className="App">
      <Router>
        <div id="Wrapper">
          <HeaderB />
          <Slider />
          {/* <Header /> */}
          <div id="Content">
            <div className="content_wrapper clearfix">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/info" element={<Information />} />
              </Routes>
            </div>
          </div>
          {/* <Footer /> */}
          <FooterB />
        </div>
      </Router>
    </div>
  );
}

export default App;
